import React from 'react'
import {Navbar,NavbarBrand,NavbarToggler,Collapse,Nav,NavItem,NavLink} from 'reactstrap'
import Logo1x from '../../static/img/co-fes-logo-white.png'
import Logo2x from '../../static/img/co-fes-logo-white@2x.png'
import Logo3x from '../../static/img/co-fes-logo-white@3x.png'
import LogoDark1x from '../../static/img/co-fes-logo-dark.png'
import LogoDark2x from '../../static/img/co-fes-logo-dark@2x.png'
import LogoDark3x from '../../static/img/co-fes-logo-dark@3x.png'


class Header extends React.Component{
     constructor(props) {
          super(props);

          this.toggle = this.toggle.bind(this);
          this.state = {
           isOpen: false,
           isTop: true
          };
     }
     componentDidMount() {
          document.addEventListener('scroll', () => {
           const isTop = window.scrollY < 100;
           if (isTop !== this.state.isTop) {
               this.setState({ isTop })
           }
          });
     }
     toggle() {
          this.setState({
           isOpen: !this.state.isOpen
          });
     }
     render(){
          return(
               <Navbar light fixed="top" expand="md" className={this.state.isTop ? 'navbar-transparent' : 'navbar-white'}>
                    <div className="container">
                      <NavbarBrand href="/"><img src={Logo1x} srcSet={`${Logo2x} 2x, ${Logo3x} 3x`} style={{width: '200px', objectFit: 'contain'}} className="logo-white" /><img src={LogoDark1x} srcSet={`${LogoDark2x} 2x, ${LogoDark3x} 3x`} style={{width: '200px', objectFit: 'contain'}} className="logo-dark" /></NavbarBrand>
                      <NavbarToggler onClick={this.toggle} />
                      <Collapse isOpen={this.state.isOpen} navbar>
                         <Nav className="ml-auto" navbar>
                          <NavItem><NavLink href="/about">ABOUT</NavLink></NavItem>
                          <NavItem><NavLink href="/students">STUDENTS</NavLink></NavItem>
                          <NavItem><NavLink href="/membership">MEMBERSHIP</NavLink></NavItem>
                          <NavItem><NavLink href="/research">RESEARCH</NavLink></NavItem>
                          <NavItem><NavLink href="/eubank-conferences">EUBANK CONFERENCE</NavLink></NavItem>
                          <NavItem><NavLink href="/news-events">NEWS & EVENTS</NavLink></NavItem>
                          {/*<NavItem><NavLink href="/history-timeline">HISTORY & TIMELINE</NavLink></NavItem>
                          <NavItem><NavLink href="/events">EVENTS</NavLink></NavItem>*/}
                          <NavItem><NavLink href="/contact">CONTACT</NavLink></NavItem>
                        </Nav>
                      </Collapse>
                 </div>
               </Navbar>
          )
     }
}
export default Header
